import { useContext } from 'react'
import { AuthValidatorContext } from '../contexts/auth'

export function useAuth() {
  const context = useContext(AuthValidatorContext);

  return context;
}
